import { Feature, Functionality } from '@frontend/functionality/types';

/** Returns footer keys to disable when TRANSACTIONS / DECEASED are missing. */
export function nivalizFooterDisabledKeys(functionalities: Pick<Functionality, 'feature'>[]): string[] {
    const disabled: string[] = [];
    if (!functionalities.some((f) => f.feature === Feature.TRANSACTIONS)) {
        disabled.push('activities');
    }
    if (!functionalities.some((f) => f.feature === Feature.DECEASED)) {
        disabled.push('deceased');
    }
    return disabled;
}
